import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { getAdvertsList } from '../companyThunks';
const SLICE_NAME = 'advertsList';

export const advertsListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getAdvertsList });
    },
});

export const advertsList = advertsListSlice.reducer;
